import $ from 'jquery';
import { SHARPSPRINGFORMIDS } from '../config';

SHARPSPRINGFORMIDS.forEach((sharpspring_form) => {
  let wordpress_form_id = '#' + sharpspring_form.wordpress_form_id;
  if ($(wordpress_form_id).length) {
    let wpcf7Elm = $(wordpress_form_id).closest('.wpcf7')[0];
    wpcf7Elm.addEventListener(
      'wpcf7mailsent',
      function (event) {
        __ss_noform.push(['submit', null, sharpspring_form.sharp_spring_id]);
      },
      false
    );
  }
});
